<template>
    <div class="main-content">
        <h1 v-translate>Compatibility Reports</h1>
        <div class="table__search">
            <input v-debounce:500="filterData" v-model="filter" type="text" class="input--text"
                   :placeholder="search__compatibility_reports_placeholder"/>
        </div>
        <div class="main-content__compatibility-reports">
            <div class="compatibility-reports__container">
                <div v-for="(report, index) in reports" class="compatibility-reports__item" @click="goTo(report)" :key="index">
                    <div class="my-people__member compatibility-reports__person-a"
                         v-bind:class="{'my-people__member--no-image': !report.target_avatar}">
                        <div v-if="report.target_avatar" class="my-people__member-image">
                            <img :src="report.target_avatar">
                        </div>
                        <div class="my-people__member-details">
                            <div class="my-people__member-name">{{report.target_name}}</div>
                        </div>
                    </div>
                    <div class="compatibility-reports__report-preview">
                        <div class="compatibility-reports__title" v-translate="{source: report.source_name, target: report.target_name}">
                            Influence of <strong class="color-primary">%{source}</strong> on <strong>%{target}</strong>
                        </div>
                        <div class="compatibility__influence-category">
                            <div class="compatibility__strength">{{getStrength(report.report.business)}}</div>
                            <div class="compatibility__details">
                                <strong v-translate>Business</strong>
                                <div class="progress-bar">
                                    <div class="progress-bar__bar" :style="{width: calculateWidth(getStrength(report.report.business))+'%'}"></div>
                                </div>
                            </div>
                        </div>
                        <div class="compatibility__influence-category">
                            <div class="compatibility__strength">{{getStrength(report.report.health)}}</div>
                            <div class="compatibility__details">
                                <strong v-translate>Health</strong>
                                <div class="progress-bar">
                                    <div class="progress-bar__bar" :style="{width: calculateWidth(getStrength(report.report.health))+'%'}"></div>
                                </div>
                            </div>
                        </div>
                        <div class="compatibility__influence-category">
                            <div class="compatibility__strength">{{getStrength(report.report.relationship)}}</div>
                            <div class="compatibility__details">
                                <strong v-translate>Relationship</strong>
                                <div class="progress-bar">
                                    <div class="progress-bar__bar" :style="{width: calculateWidth(getStrength(report.report.relationship))+'%'}"></div>
                                </div>
                            </div>
                        </div>
                        <div class="compatibility__influence-category">
                            <div class="compatibility__strength">{{getStrength(report.report.personal)}}</div>
                            <div class="compatibility__details">
                                <strong v-translate>Personal</strong>
                                <div class="progress-bar">
                                    <div class="progress-bar__bar" :style="{width: calculateWidth(getStrength(report.report.personal))+'%'}"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="my-people__member compatibility-reports__person-b"
                         v-bind:class="{'my-people__member--no-image': !report.target_avatar}">
                        <div v-if="report.source_avatar" class="my-people__member-image">
                            <img :src="report.source_avatar">
                        </div>
                        <div class="my-people__member-details">
                            <div class="my-people__member-name">{{report.source_name}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="compatibility-reports__new-report">
                <router-link :to="{name:'compatibility'}" class="button button--primary"><translate>Create new compatibility report</translate></router-link>
                <div v-if="allowance>0 && loaded" class="compatibility__credits-left" key="allowance-1" v-translate="{allowance_text: allowance}"><strong>%{allowance_text}</strong> compatibility reports left to generate</div>
                <div v-if="allowance===0 && loaded" class="compatibility__credits-left" key="allowance-2" v-translate><strong>0</strong> compatibility reports left to generate.<br>Upgrade package or buy credits (available soon).</div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';
    import axios from 'axios';

    export default {
        name: 'MyReports-CompatibilityReports',
        data() {
            return {
                loaded: false,
                allowance: 0,
                reports: [],
                filter: '',
                search__compatibility_reports_placeholder: this.$gettext('Search Reports..'),
            }
        },
        methods: {
            ...mapActions([
                'openPopup'
            ]),
            calculateWidth: function (strength) {
                if (strength === 3) {
                    return 100
                }
                return strength * 33.3
            },
            getStrength: function(obj) {
                let arr = Object.values(obj);
                return Math.max(...arr);
            },
            goTo: function(report) {
                this.$router.push({ name: 'compatibility-details', params: { id: report.id }})
            },
            filterData: async function (val) {
                let url = process.env.VUE_APP_ZEEQUEST_URL + 'api/navigator/compatibility-reports/?query=' + val;
                this.reports = (await axios.get(url)).data
            },
        },
        beforeMount: async function() {
            this.allowance = (await axios.get('/api/navigator/allowance/')).data.compatibility
            this.reports = (await axios.get('/api/navigator/compatibility-reports/')).data
            this.loaded = true
        },
    }
</script>
